import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { times } from 'lodash';
import cx from 'classnames';

import personalLabelMap, {
  personalLabelProptypes,
} from 'sharedParts/config/personalLabelMap';
import numbering from 'sharedParts/utils/numbering';

import getSubLabelByType from '../../../../utils/getSubLabelByType';
import styles from './RatingIndex.scss';

export default class RatingIndex extends Component {
  static propTypes = {
    count: PropTypes.number,
    ratingItemClassName: PropTypes.string,
    startFromZero: PropTypes.bool,
    containerClassName: PropTypes.string,
    personalLabelType: personalLabelProptypes,
  };

  static defaultProps = {
    startFromZero: false,
  };

  getLabel = index => {
    const { startFromZero, personalLabelType: labelType } = this.props;
    const typeLabel = getSubLabelByType({ labelType, index, startFromZero });
    const noTypeLabel = startFromZero ? index : numbering.toHuman(index);
    return typeLabel || noTypeLabel;
  };

  renderRatingItems() {
    const {
      count: length,
      containerClassName,
      ratingItemClassName,
      personalLabelType: labelType,
    } = this.props;

    const indexes = times(length);

    if (labelType === personalLabelMap.numberDesc) {
      indexes.reverse();
    }

    return (
      <div className={cx(styles.container, containerClassName)}>
        {indexes.map(item => (
          <span key={item} className={cx(ratingItemClassName, styles.personal)}>
            {this.getLabel(item)}
          </span>
        ))}
      </div>
    );
  }

  render() {
    const { personalLabelType: labelType } = this.props;

    const shouldHideIndexLabel = personalLabelMap.noLabel === labelType;

    return shouldHideIndexLabel ? null : this.renderRatingItems();
  }
}
